import SessionService from './SessionService';

import axios from 'axios';

export default class HttpService {
  constructor() {
    this.sessionService = new SessionService();
  }

  async Request(url, options, isRetry = false) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    };

    const accessToken = this.sessionService.ResolveAccessToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return axios(`${process.env.REACT_APP_API_URL}/${url}`, {
      headers,
      ...options,
    })
      .then(async (response) => {
        let result = {};
        result.success = !!(response.status >= 200 && response.status < 300);
        result.payload = response.data;
        return result;
      })
      .catch(async (error) => {
        let result = {};
        result.success = false;
        if (error) {
          if (error.response) {
            if (error.response.status === 401 && !isRetry) {
              await this.RefreshToken()
                .then((res) => {
                  if (res.success) {
                    this.sessionService.StoreAccessToken(
                      res.payload.accessToken
                    );
                    this.sessionService.StoreRefreshToken(
                      res.payload.refreshToken
                    );
                  }
                })
                .catch(() => {})
                .finally(() => {});
              return this.Request(url, options, true);
            }
            result.payload = error.response.data;
          }
        }
        throw error;
      });
  }

  async IdentityRequest(url, options, isRetry = false) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    };

    const accessToken = this.sessionService.ResolveAccessToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return axios(`${process.env.REACT_APP_IDENTITY_URL}/${url}`, {
      headers,
      ...options,
    })
      .then(async (response) => {
        let result = {};
        result.success = !!(response.status >= 200 && response.status < 300);
        result.payload = response.data;
        return result;
      })
      .catch(async (error) => {
        let result = {};
        result.success = false;
        if (error) {
          if (error.response) {
            if (error.response.status === 401 && !isRetry) {
              await this.RefreshToken()
                .then((res) => {
                  if (res.success) {
                    this.sessionService.StoreAccessToken(
                      res.payload.accessToken
                    );
                    this.sessionService.StoreRefreshToken(
                      res.payload.refreshToken
                    );
                  }
                })
                .catch(() => {})
                .finally(() => {});
              return this.Request(url, options, true);
            }
            result.payload = error.response.data;
          }
        }
        throw error;
      });
  }

  async RefreshToken() {
    const data = {
      accessToken: this.sessionService.ResolveAccessToken(),
      refreshToken: this.sessionService.ResolveRefreshToken(),
    };
    return this.IdentityRequest('identity/refresh-token', {
      method: 'POST',
      data: data,
    });
  }

  async Upload(url, options, isRetry = false) {
    const headers = {
      'Content-Type': 'text/csv; charset=utf-8',
    };

    const accessToken = this.sessionService.ResolveAccessToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return axios(`${process.env.REACT_APP_API_URL}/${url}`, {
      headers,
      method: 'PUT',
      ...options,
    })
      .then(async (response) => {
        let result = {};
        result.success = !!(response.status >= 200 && response.status < 300);
        result.payload = response.data;
        return result;
      })
      .catch(async (error) => {
        let result = {};
        result.success = false;
        if (error) {
          if (error.response) {
            if (error.response.status === 401 && !isRetry) {
              await this.RefreshToken()
                .then((res) => {
                  if (res.success) {
                    this.sessionService.StoreAccessToken(
                      res.payload.accessToken
                    );
                    this.sessionService.StoreRefreshToken(
                      res.payload.refreshToken
                    );
                  }
                })
                .catch(() => {})
                .finally(() => {});
              return this.Request(url, options, true);
            }
            result.payload = error.response.data;
          }
        }
        throw error;
      });
  }
}
